"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCALE_LEGEND_CATEGORY_KEY = 'base';
exports.SCALE_LEGEND_COMPONENT_KEY = 'scaleLegend';